module.exports = __webpack_public_path__ + "img/srm-title-bg.6c993d99.png";